/**
 * Per-language strings used on the card. `script` drives the font stack so
 * each Indic script renders with a face that actually supports it.
 */
export const LANGUAGES = {
  hi: {
    name: "Hindi",
    script: "devanagari",
    govt: "भारत सरकार",
    uidai: "भारतीय विशिष्ट पहचान प्राधिकरण",
    dob: "जन्म तिथि",
    address: "पता",
    gender: { male: "पुरुष", female: "महिला", other: "अन्य" },
    specimen: "नमूना — वैध दस्तावेज़ नहीं",
  },
  gu: {
    name: "Gujarati",
    script: "gujarati",
    govt: "ભારત સરકાર",
    uidai: "ભારતીય વિશિષ્ટ ઓળખ પ્રાધિકરણ",
    dob: "જન્મ તારીખ",
    address: "સરનામું",
    gender: { male: "પુરુષ", female: "સ્ત્રી", other: "અન્ય" },
    specimen: "નમૂનો — માન્ય દસ્તાવેજ નથી",
  },
  mr: {
    name: "Marathi",
    script: "devanagari",
    govt: "भारत सरकार",
    uidai: "भारतीय विशिष्ट ओळख प्राधिकरण",
    dob: "जन्म दिनांक",
    address: "पत्ता",
    gender: { male: "पुरुष", female: "महिला", other: "इतर" },
    specimen: "नमुना — वैध दस्तऐवज नाही",
  },
  ta: {
    name: "Tamil",
    script: "tamil",
    govt: "இந்திய அரசு",
    uidai: "இந்திய தனித்துவ அடையாள ஆணையம்",
    dob: "பிறந்த தேதி",
    address: "முகவரி",
    gender: { male: "ஆண்", female: "பெண்", other: "மற்றவை" },
    specimen: "மாதிரி — செல்லுபடியாகும் ஆவணம் அல்ல",
  },
  ml: {
    name: "Malayalam",
    script: "malayalam",
    govt: "ഭാരത സർക്കാർ",
    uidai: "ഇന്ത്യൻ അതുല്യ തിരിച്ചറിയൽ അതോറിറ്റി",
    dob: "ജനന തീയതി",
    address: "വിലാസം",
    gender: { male: "പുരുഷൻ", female: "സ്ത്രീ", other: "മറ്റുള്ളവ" },
    specimen: "മാതൃക — സാധുവായ രേഖയല്ല",
  },
  kn: {
    name: "Kannada",
    script: "kannada",
    govt: "ಭಾರತ ಸರ್ಕಾರ",
    uidai: "ಭಾರತೀಯ ವಿಶಿಷ್ಟ ಗುರುತಿನ ಪ್ರಾಧಿಕಾರ",
    dob: "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
    address: "ವಿಳಾಸ",
    gender: { male: "ಪುರುಷ", female: "ಮಹಿಳೆ", other: "ಇತರೆ" },
    specimen: "ಮಾದರಿ — ಮಾನ್ಯ ದಾಖಲೆ ಅಲ್ಲ",
  },
  te: {
    name: "Telugu",
    script: "telugu",
    govt: "భారత ప్రభుత్వం",
    uidai: "భారత విశిష్ట గుర్తింపు ప్రాధికార సంస్థ",
    dob: "పుట్టిన తేదీ",
    address: "చిరునామా",
    gender: { male: "పురుషుడు", female: "స్త్రీ", other: "ఇతర" },
    specimen: "నమూనా — చెల్లుబాటు అయ్యే పత్రం కాదు",
  },
  bn: {
    name: "Bengali",
    script: "bengali",
    govt: "ভারত সরকার",
    uidai: "ভারতীয় স্বতন্ত্র পরিচয় কর্তৃপক্ষ",
    dob: "জন্ম তারিখ",
    address: "ঠিকানা",
    gender: { male: "পুরুষ", female: "মহিলা", other: "অন্যান্য" },
    specimen: "নমুনা — বৈধ নথি নয়",
  },
  pa: {
    name: "Punjabi",
    script: "gurmukhi",
    govt: "ਭਾਰਤ ਸਰਕਾਰ",
    uidai: "ਭਾਰਤੀ ਵਿਲੱਖਣ ਪਛਾਣ ਅਥਾਰਟੀ",
    dob: "ਜਨਮ ਮਿਤੀ",
    address: "ਪਤਾ",
    gender: { male: "ਪੁਰਸ਼", female: "ਔਰਤ", other: "ਹੋਰ" },
    specimen: "ਨਮੂਨਾ — ਵੈਧ ਦਸਤਾਵੇਜ਼ ਨਹੀਂ",
  },
  or: {
    name: "Odia",
    script: "odia",
    govt: "ଭାରତ ସରକାର",
    uidai: "ଭାରତୀୟ ବିଶିଷ୍ଟ ପରିଚୟ ପ୍ରାଧିକରଣ",
    dob: "ଜନ୍ମ ତାରିଖ",
    address: "ଠିକଣା",
    gender: { male: "ପୁରୁଷ", female: "ମହିଳା", other: "ଅନ୍ୟାନ୍ୟ" },
    specimen: "ନମୁନା — ବୈଧ ଦଲିଲ ନୁହେଁ",
  },
  as: {
    name: "Assamese",
    script: "bengali",
    govt: "ভাৰত চৰকাৰ",
    uidai: "ভাৰতীয় বিশিষ্ট পৰিচয় কৰ্তৃপক্ষ",
    dob: "জন্ম তাৰিখ",
    address: "ঠিকনা",
    gender: { male: "পুৰুষ", female: "মহিলা", other: "অন্যান্য" },
    specimen: "নমুনা — বৈধ নথি নহয়",
  },
  ne: {
    name: "Nepali",
    script: "devanagari",
    govt: "भारत सरकार",
    uidai: "भारतीय विशिष्ट पहिचान प्राधिकरण",
    dob: "जन्म मिति",
    address: "ठेगाना",
    gender: { male: "पुरुष", female: "महिला", other: "अन्य" },
    specimen: "नमुना — वैध कागजात होइन",
  },
  kok: {
    name: "Konkani",
    script: "devanagari",
    govt: "भारत सरकार",
    uidai: "भारतीय विशिष्ट वळख प्राधिकरण",
    dob: "जल्म तारीख",
    address: "नामो",
    gender: { male: "दादलो", female: "बायल", other: "हेर" },
    specimen: "नमुनो — वैध दस्तावेज न्हय",
  },
};

/* Filler names are no longer held here. They used to be four curated
   English/local pairs sharing the surname "Namuna" - the word for "sample" -
   which read as obviously fake on a card. utils/fictional.js now draws real
   names from the shipped pool and transliterates them per script, the same
   way a name typed by the user is handled, so no per-script spelling has to
   be maintained alongside this file. */
